import React from 'react'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import type { TaskDetailsComponentProps } from '../../task-details/types'
import TaskDetailsActionButtons from '../task-details-action-buttons'

export const getActionButtons = (props: TaskDetailsComponentProps) => {
  const { task } = props

  if (task.statusFe === TASK_STATES.closed) return null

  return <TaskDetailsActionButtons {...props} />
}
